import { render } from "./ClimatizacaoPage.vue?vue&type=template&id=00a7438b&scoped=true"
import script from "./ClimatizacaoPage.vue?vue&type=script&lang=js"
export * from "./ClimatizacaoPage.vue?vue&type=script&lang=js"

import "./ClimatizacaoPage.vue?vue&type=style&index=0&id=00a7438b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a7438b"]])

export default __exports__